type EmailType = {
  fill: string
  width: string
  height: string
  title: string
}

function Email(props: EmailType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'email'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 23 19'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M21.3229 4.58854L21.5625 4.46875L11.5 9.5L1.4375 4.46875L1.67708 4.58854'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M19.1667 1.35352H3.83333C2.51015 1.35352 1.4375 2.42617 1.4375 3.74935V15.2493C1.4375 16.5725 2.51015 17.6452 3.83333 17.6452H19.1667C20.4898 17.6452 21.5625 16.5725 21.5625 15.2493V3.74935C21.5625 2.42617 20.4898 1.35352 19.1667 1.35352Z'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default Email
